import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Pages } from '../../../../../common/src/pages.ts';
import { getUrlForPage } from '../../../util/path.ts';
import { EngineeringAdminWrapper } from './shared.tsx';

export const EngineeringPage = () => {
  return (
    <EngineeringAdminWrapper title={'Engineering'}>
      <LinkList>
        <LinkWrapper key={Pages.EngineeringCustomMusic}>
          <Link to={getUrlForPage(Pages.EngineeringCustomMusic)}>Custom Music</Link>
        </LinkWrapper>
        <LinkWrapper key={Pages.EngineeringBrokenSongs}>
          <Link to={getUrlForPage(Pages.EngineeringBrokenSongs)}>Broken Songs</Link>
        </LinkWrapper>
        <LinkWrapper key={Pages.EngineeringManageHouseholds}>
          <Link to={getUrlForPage(Pages.EngineeringManageHouseholds)}>Manage Households</Link>
        </LinkWrapper>
        <LinkWrapper key={Pages.EngineeringAudioLab}>
          <Link to={getUrlForPage(Pages.EngineeringAudioLab)}>Audio Lab</Link>
        </LinkWrapper>
        <LinkWrapper key={Pages.Huddle}>
          <Link to={getUrlForPage(Pages.Huddle)}>Morning Huddle</Link>
        </LinkWrapper>
      </LinkList>
    </EngineeringAdminWrapper>
  );
};

const LinkList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  gap: 20px;
`;

const LinkWrapper = styled.div`
  font-size: 1.3rem;
`;
